class RecaptchaService {
  getInvisibleSiteKey () {
    return process.env.VUE_APP_INVISIBLE_RECAPTCHA_SITE_KEY;
  }
}

export default new RecaptchaService();
